'use strict';

module.exports = (checkoutGtmData) => {
    return {
        /* eslint-disable camelcase */
        namespaced: true,
        state: {
            gtm: require('../../../../modules/google').tagManager,
            lastInteractionBlock: '',
            shippingOptionEvent: {
                event: 'add_shipping_info',
                content_group: 'delivery',
                method: '',
                shipping_tier: '',
                page_location: '/checkout/delivery'
            },
            deliveryEventPushed: false,
            detailsEventPushed: false,
            paymentEventPushed: false
        },
        /* eslint-enable camelcase */
        mutations: {
            handleDeliveryInteraction(state, method) {
                if (!state.deliveryEventPushed) {
                    checkoutGtmData.delivery_method = method.toLowerCase();
                    const event = Object.assign({}, checkoutGtmData);
                    event.step = 2;
                    event.step_name = 'add delivery method';
                    state.gtm.pushDataLayerEvent(event);
                    state.deliveryEventPushed = true;
                }
            },

            handleDetailsInteraction(state) {
                if (!state.detailsEventPushed) {
                    const event = Object.assign({}, checkoutGtmData);
                    event.step = 3;
                    event.step_name = 'add shipping info';
                    state.gtm.pushDataLayerEvent(event);
                    state.detailsEventPushed = true;
                }
            },

            handlePaymentsInteraction(state, paymentMethod) {
                if (!state.paymentEventPushed) {
                    checkoutGtmData.payment_method = paymentMethod && paymentMethod.name ? paymentMethod.name.toLowerCase() : null;
                    const event = Object.assign({}, checkoutGtmData);
                    event.step = 4;
                    event.step_name = 'add payment method';
                    state.gtm.pushDataLayerEvent(event);
                    state.paymentEventPushed = true;
                }
            },

            handleViewComponent(state, method) {
                checkoutGtmData.delivery_method = method.toLowerCase();
                const event = Object.assign({}, checkoutGtmData);
                event.step = 1;
                event.step_name = 'start checkout';
                state.gtm.pushDataLayerEvent(event);
            },

            handlePlaceOrderInteraction(state) {
                const event = Object.assign({}, checkoutGtmData);
                event.step = 5;
                event.step_name = 'complete checkout';
                state.gtm.pushDataLayerEvent(event);
            },

            handleCheckoutFieldError(state, {section, message}) {
                const optionEvent = {};
                optionEvent.event = 'form_field_error';
                optionEvent.error_type = 'form_field_error';
                optionEvent.error_message = message.toLowerCase() || null;
                optionEvent.error_code = null;
                optionEvent.content_name = 'checkout - ' + section;

                state.gtm.pushDataLayerEvent(optionEvent);
            },
        }
    };
};
